import { jsx as _jsx } from "react/jsx-runtime";
import MuiIconButton from '@mui/material/IconButton';
import MUIICon from '@mui/material/Icon';
import { DateRangePickerTestAttributes } from '@famly/mf_util_date-range-picker-test-attributes';
/**
 * The PreviousIconButton "slots" unfortunately types its props as "any". Reflecting that here.
 */
export const PreviousIconButton = (props) => {
    return (_jsx(MuiIconButton, { ...props, sx: theme => ({ width: 36, height: 36, color: theme.modernFamlyTheme.colorPalette.n400 }), children: _jsx(MUIICon, { "data-e2e-id": DateRangePickerTestAttributes.previousMonthButton, sx: {
                fontSize: `24px`,
                color: 'inherit',
            }, children: "chevron_left" }) }));
};
/**
 * The NextIconButton "slots" unfortunately types its props as "any". Reflecting that here.
 */
export const NextIconButton = (props) => {
    return (_jsx(MuiIconButton, { ...props, sx: theme => ({ width: 36, height: 36, color: theme.modernFamlyTheme.colorPalette.n400 }), children: _jsx(MUIICon, { "data-e2e-id": DateRangePickerTestAttributes.nextMonthButton, sx: {
                fontSize: `24px`,
                color: 'inherit',
            }, children: "chevron_right" }) }));
};
export const MF_DATE_DIALOG_PADDING = 6;
